module.exports = __webpack_public_path__ + "media/images/fbcalls/bybit-7d2880067d03f5c29151563564afb6e3.png";